"use client";

import { useEffect } from "react";
import { setLastWorkspaceIdCookie } from "@/lib/cookie/cookie-client";

export function WorkspaceIdTracker({ workspaceId }: { workspaceId: string }) {
  useEffect(() => {
    // ワークスペースIDが変更されたときに自動的にcookieに保存
    setLastWorkspaceIdCookie(workspaceId);
  }, [workspaceId]);

  return null;
}
